import { render } from "./StockGeneric.vue?vue&type=template&id=1c0be562"
import script from "./StockGeneric.vue?vue&type=script&lang=ts"
export * from "./StockGeneric.vue?vue&type=script&lang=ts"
script.render = render

export default script